
const userId = localStorage.getItem('userId')
const characters = '0123456789abcdefghijklmnopqrstuvwxyz';
const linkUrl = localStorage.getItem('linkUrl');
let token = ""

for (let i = 0; i < 16; i++) {
    token += characters.charAt(Math.floor(Math.random() * characters.length));
  }

const link = `${linkUrl}/forgot-pass-email?mode=action&oobCode=${token}&userId=${userId}`
export let resetPasswordEmail = {
    // title: "Redefinição de senha",
    // subject: "Redefinição de senha",
    body: `<!DOCTYPE html>
    <html>
        <style>
        .bold, strong  {font-weight:600;font-family: 'Red Hat Display', sans-serif;}
        p, body{
            margin: 0 auto;
        }
        </style>
        <link href="https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;500;700&display=swap" rel="stylesheet">
        <body>
            <div style="margin-left: 0; margin-right: 0; padding-top: 30px; padding-bottom: 30px; background-color: #dee8ec;">
                <table width="600" valign="top" style="margin: 0 auto; text-align:center; font-size: 16px; font-family: 'Red Hat Display', sans-serif; color: gray; text-align: center; background-color: #fffff">
                    <tr>
                        <td style="background-color: #ffffff">
                            <center><img src='[img]' alt='[title]' style="text-align: center; width: 100%;"/></center>
                            <p class="bold" style="font-weight:600; font-size: 30px; font-family: 'Red Hat Display', sans-serif; margin-bottom: 0; margin-top: 40px; margin-left: 40px; margin-right: 40px; color: gray; text-align: center;">[txt0]</p>
                            <center><p style="width: 300px; padding-top: 5px; line-height: 24px; padding-bottom: 5px; font-family: 'Red Hat Display', sans-serif; margin-left: 40px; margin-right: 40px;">[txt1]</p></center>
                            <center><a href="${link}"><button style="width: 260px; border-radius: 40px; height: 53px; background-color: #fe6552; color: white; border: none; text-align: center; font-family: 'Red Hat Display', sans-serif; font-size: 14px; font-weight: 600; letter-spacing: 2px; margin-bottom: 30px; margin-top: 30px;">[txt2]</button></a></center>
                            <p style="margin-bottom: 10px; text-align: center; font-family: 'Red Hat Display', sans-serif;">[txt3]</p>
                            <a href="${link}" style="font-family: 'Red Hat Display', sans-serif;">${link}</a>
                            <center><p style="text-align: center; width: 380px; padding-top: 30px; padding-bottom: 40px; font-family: 'Red Hat Display', sans-serif; line-height: 24px">[txt4]</p></center>
                            <hr style="color: #dbe0e3; border-color: #dbe0e3; border: 1px solid; margin-left: 50px; margin-right: 50px;">
                            <center><p style="width: 450px; font-size: 13px; color: gray; text-align: center; text-align: center; font-family: 'Red Hat Display', sans-serif; padding-top:16px; padding-bottom: 60px">[txt5] <strong>support@huddlebrasil.zendesk.com</strong></p></center>
                        </td>
                    </tr>
                </table>
            </div>
        </body>
    </html>

`}